import React from 'react';
import { Card, InputNumber, Col, Tag, Row, Tooltip } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import eshopData from '../enums/data.json'
const { Meta } = Card;

const createCard = (data, addCallback, index) => {
  if (!data) return null;
  const {
    id,
    label,
    descr,
    minidescr,
    price,
    isNew,
    isXmas,
    isNealko,
  } = data;
  const cardKey = id ?? label ?? `item-${index}`;
  return (
    <Col key={cardKey} xs={24} md={12} lg={12} xl={8} xxl={8}>


      <Card
        // style={{ height: 300 }}
        cover={
          <div>
            {isNew ? <Tag color="#f50">Novinka!</Tag> : null}
            {isXmas ? <Tag color="#4cc779">Vánoční speciál!</Tag> : null}
            {isNealko ? <Tag color="#89cff0">Nealko</Tag> : null}
            <img
              alt={label || 'Produkt'}
              src={id ? process.env.PUBLIC_URL + `/resized_images/${id}.jpg` : undefined}
              // src={data.image}
              style={{ maxHeight: "200px", width: 'auto', display: 'block', margin: '0 auto', paddingTop: 5 }}
            />
          </div>
        }
      >

        <Meta
          title={<Tooltip title={label || ''}>{label || ''}</Tooltip>}
          style={{
            marginBottom: 10,
            wordBreak: 'break-word', // Ensures words break only where appropriate
            overflowWrap: 'break-word', // Ensures long words fit within the container
          }}
        />
        <div style={{ minHeight: 150 }}>
          <div style={{ textAlign: 'left', marginBottom: 10 }}>
            <span>{descr}</span>
          </div>
          <div style={{ textAlign: 'center', marginBottom: 10 }}>
            <span>{minidescr}</span>
          </div>
          <div style={{ textAlign: 'center' }}>
            <InputNumber size="small" min={0} max={eshopData.rules.maxOrderItems} defaultValue={0} onChange={(el) => addCallback?.(id, el, data)} />
            <ShoppingCartOutlined style={{ marginLeft: 10, marginRight: 5 }} />
            <span>{price} Kč</span>
          </div>

        </div>
      </Card>
    </Col>
  )
}


export default function Items(props) {
  const items = Array.isArray(props.items) ? props.items : [];
  const sortedItems = [...items].sort((a, b) => (b?.isNew || 0) - (a?.isNew || 0));

  return (
    <Row gutter={[8, 8]}>
      {sortedItems.map((el, index) => createCard(el, props.addItem, index))}
    </Row>


  )
}
